var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("table", { staticClass: "parking-details full-width" }, [
    _c("tbody", [
      _c("tr", [
        _c("td", [_vm._v(_vm._s(_vm.$t("cancellation_policy")))]),
        _vm._v(" "),
        !(_vm.location && _vm.location.reslab_id) ||
        (_vm.parkingCancellationPolicies &&
          _vm.parkingCancellationPolicies.fullyRefundableUntillStart)
          ? _c("td", [_vm._v(_vm._s(_vm.$t("free_until_start_time")))])
          : _c("td", [
              _vm.parkingCancellationPolicies
                ? _c("div", [
                    _vm.parkingCancellationPolicies.formattedDate
                      ? _c("div", [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("parking_fully_refundable_until")) +
                              " " +
                              _vm._s(
                                _vm.parkingCancellationPolicies.formattedDate
                              ) +
                              "\n          "
                          )
                        ])
                      : _c("div", [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("parking_fully_refundable_until")) +
                              " " +
                              _vm._s(
                                _vm.parkingCancellationPolicies
                                  .fullyRefundabledays
                              ) +
                              " " +
                              _vm._s(_vm.$t("days")) +
                              " " +
                              _vm._s(_vm.$t("before_start_time")) +
                              "\n          "
                          )
                        ])
                  ])
                : _c("div", [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("parking")) +
                        " " +
                        _vm._s(_vm.$t("non_refundable")) +
                        "\n        "
                    )
                  ])
            ])
      ]),
      _vm._v(" "),
      _c("tr", [
        _c("td", [_vm._v("Shuttle service")]),
        _vm._v(" "),
        _c("td", [_vm._v(_vm._s(_vm.location.shuttle_service ? "Yes" : "No"))])
      ]),
      _vm._v(" "),
      _c("tr", [
        _c("td", [_vm._v("Adapted for disabled")]),
        _vm._v(" "),
        _c("td", [
          _vm._v(
            "\n        " +
              _vm._s(
                _vm.checkAmenityNameExists(_vm.location, "handiCap") ||
                  _vm.checkAmenityNameExists(_vm.location, "handi_cap")
                  ? "Yes"
                  : "No"
              ) +
              "\n      "
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-bc200724", { render: render, staticRenderFns: staticRenderFns })
  }
}